import { Controller } from "@hotwired/stimulus"

// Scrolls a horizontally-overflowing tab bar so the active tab is in view
// after navigation. The tab strip natively resets scroll-left to 0 on each
// page load — without this controller, the operator who clicked the last
// tab lands on a page where the scroll still shows the first tabs.
//
// We mutate `scrollLeft` directly instead of using scrollIntoView because
// the latter happily scrolls the document's vertical axis too if the
// browser decides the element isn't "near enough", which manifests as a
// visible page jump.
export default class extends Controller {
  connect() {
    const active = this.element.querySelector('[aria-current="page"]')
    if (!active) return

    // Run synchronously in connect() — wrapping this in requestAnimationFrame
    // would push the mutation past the next paint, which the operator sees
    // as a quick "jump" from scroll=0 to the centred position. Layout is
    // already measurable here because Stimulus connect() fires after the
    // element is in the DOM and CSS is applied.
    const containerRect = this.element.getBoundingClientRect()
    const elementRect = active.getBoundingClientRect()
    const offset =
      elementRect.left -
      containerRect.left +
      elementRect.width / 2 -
      containerRect.width / 2
    this.element.scrollLeft += offset
  }
}
